export const ds_EventsCalendarBlock_Entry = `
    fragment ds_EventsCalendarBlock_Entry on ds_EventsCalendarBlock_Entry {
        id
        canonicalUid
        eventsCalendar_ContainerWidth
        eventsCalendar_TopSpacing
        eventsCalendar_ColorTheme
        eventsCalendar_ColorPalette
        eventsCalendar_FullWidthBackground

        eventsCalendar_Heading
        eventsCalendar_BodyText
        eventsCalendar_Integration {
            category
            integration
        }
    }
`